import { WsMsgType } from 'lib_ts/enums/machine-msg.enum';
import { sendSocketMessage } from 'services/socket';

// todo: get rid of this shim
export class WebSocketService {
  // returns flag for success
  static send = sendSocketMessage;

  // returns flag for success
  static sendWithoutRetry = (type: WsMsgType, data: any, source: string) =>
    sendSocketMessage(type, data, source, false); // false => no retry
}
